import Loader from "./Loader";
export default function PageLoader(props) {
  return (
    <div className="d-flex h-100 w-100 justify-content-center align-items-center">
      <Loader className={"spinner-border-lg " + props.className} />
    </div>
  );
}
